export default {
  // Fetch global search results
  FETCH_GLOBAL_SEARCH_RESULTS: "FETCH_GLOBAL_SEARCH_RESULTS",
  // Set global search value
  SET_GLOBAL_SEARCH_VALUE: "SET_GLOBAL_SEARCH_VALUE",
  // Reset global search value
  RESET_GLOBAL_SEARCH_RESULTS: "RESET_GLOBAL_SEARCH_RESULTS",
};
